import axios from 'axios';
import constants from '../constants';

export type NodusPathOptions = 'payments' | 'paymentsHistory';

export const getEPayLink = (customerNumber: string, option: NodusPathOptions) =>
  axios.post(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/nodus/url`, { customer_number: customerNumber, path: option }).then(({ data }) => data);
